(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-avatar-example-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-avatar-examples-prev]');
    var next = event.target.closest('[data-avatar-examples-next]');

    if (!prev && !next) {
      return;
    }

    var wrap = event.target.closest('.avatar-examples__wrap');
    var scroller = wrap && wrap.querySelector('.avatar-examples__scroller');

    if (!scroller) {
      return;
    }

    scroller.scrollBy({ left: next ? 420 : -420, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-avatar-hero-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var galleryArrow = event.target.closest('[data-avatar-hero-gallery-prev], [data-avatar-hero-gallery-next]');
    if (galleryArrow) {
      var gallery = galleryArrow.closest('.avatar-hero__gallery');
      var scroller = gallery && gallery.querySelector('.avatar-hero__gallery-scroll');

      if (scroller) {
        var direction = galleryArrow.hasAttribute('data-avatar-hero-gallery-prev') ? -1 : 1;
        scroller.scrollBy({ left: direction * 180, behavior: 'smooth' });
      }

      return;
    }

    var copyButton = event.target.closest('[data-avatar-hero-copy-link]');
    if (copyButton) {
      var link = copyButton.getAttribute('data-avatar-hero-copy-link');

      if (navigator.clipboard && link) {
        navigator.clipboard.writeText(link);
      }

      copyButton.classList.add('is-copied');
      window.setTimeout(function () {
        copyButton.classList.remove('is-copied');
      }, 1400);

      return;
    }

    var thumb = event.target.closest('[data-avatar-hero-thumb]');

    if (!thumb) {
      return;
    }

    var section = thumb.closest('.avatar-hero');
    var mainImage = section && section.querySelector('.avatar-hero__main-image');
    var fullImage = thumb.getAttribute('data-full-image');

    if (!mainImage || !fullImage) {
      return;
    }

    mainImage.removeAttribute('srcset');
    mainImage.src = fullImage;

    section.querySelectorAll('[data-avatar-hero-thumb]').forEach(function (button) {
      button.classList.toggle('is-active', button === thumb);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
